import Header from "../01_header/header"
import Footer from "../02_footer/footer"

import './09_pagenotfound_component.css'

import { HelmetProvider } from 'react-helmet-async';

export default function NotFound() {
    return (
        <div>
            <HelmetProvider>
                <title>Leading Digital Solutions for Businesses in Mumbai</title>
                <meta name="Adstrate is a digital marketing agency in Mumbai offering social media marketing in Mumbai, Instagram marketing agency services, and strategic social media content creation." />
                <link rel="canonical" href="https://adstrate.in/about" />
            </HelmetProvider>
            <Header />
                <div className="NotFoundPage">
                    <h1>404</h1>
                    <p className="NotFoundPage-Ops">Oops... Something went wrong</p>
                    <p className="NotFoundPage-Des">We can't find the page you are looking for</p>
                    <a href="/">Home</a>
                </div>
            <Footer />
        </div>
    );
}